import { React } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

import { AiOutlineSearch } from "react-icons/ai";
import { SearchStyle } from "./style";

function SearchComponent({ filterBySearch }) {
  return (
    <SearchStyle>
      <InputGroup
        className="mb-3"
        onChange={(event) => filterBySearch(event.target.value)}
      >
        <InputGroup.Text><AiOutlineSearch/></InputGroup.Text>
        <Form.Control placeholder="Filtro por qualquer coluna da tabela..." />
      </InputGroup>
    </SearchStyle>
  );
}

export default SearchComponent;
